export default "__VITE_ASSET__CAZVva2f__"